import AccountTypeSelector from './AccountTypeSelector';

export default AccountTypeSelector;
